import { useState, type FormEvent, type KeyboardEvent } from "react";

interface ComposerProps {
  disabled: boolean;
  onSend: (text: string) => void;
  placeholder?: string;
}

export function Composer({ disabled, onSend, placeholder }: ComposerProps) {
  const [draft, setDraft] = useState("");

  const submit = (e: FormEvent) => {
    e.preventDefault();
    const text = draft.trim();
    if (!text || disabled) return;
    onSend(text);
    setDraft("");
  };

  const onKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      submit(e);
    }
  };

  return (
    <form
      onSubmit={submit}
      className="flex items-end gap-2 rounded-2xl border border-jg-border bg-jg-bg-soft/80 p-2 backdrop-blur-md focus-within:border-jg-ai/60"
    >
      <label htmlFor="ai-composer" className="sr-only">
        Ask the JGson assistant
      </label>
      <textarea
        id="ai-composer"
        rows={1}
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={onKeyDown}
        disabled={disabled}
        placeholder={placeholder ?? "Ask about JGson…"}
        className="min-h-[2.25rem] max-h-32 flex-1 resize-none bg-transparent px-2 py-1.5 text-sm text-jg-fg outline-none placeholder:text-jg-fg-muted disabled:opacity-60 sm:text-[15px]"
      />
      <button
        type="submit"
        disabled={disabled || draft.trim().length === 0}
        className="shrink-0 rounded-xl bg-jg-ai px-3 py-1.5 text-sm font-semibold text-jg-bg transition-opacity disabled:opacity-40 enabled:hover:opacity-90"
      >
        Send
      </button>
    </form>
  );
}
